import { assign, fromPromise, setup } from 'xstate';
import { showAxiosErrorAction } from '~/features/actions';
import { loadingFalse, loadingTrue, setData } from './actions';
import { LICENSE_API_CALLS } from './api';
import { Events } from './events';
import { Context, Scope } from './types';

export const combinedLicenseMachine = setup({
  actors: {
    getData: fromPromise(LICENSE_API_CALLS.get),
  },
  types: {
    context: {} as Context,
    events: {} as Events,
    input: {} as Partial<Context>,
  },
  actions: {
    loadingTrue: assign(loadingTrue),
    loadingFalse: assign(loadingFalse),
    setData: assign(setData),
    sendError: showAxiosErrorAction,
  },
}).createMachine({
  context: ({ input }) => ({
    loading: false,
    error: false,
    providerId: input.providerId || 0,
    pagination: input.pagination || {
      page: 1,
      pageSize: 10,
      total: 0,
    },
    modal: input.modal || {
      edit: false,
      create: false,
    },
    form: input.form || {},
    data: input.data || [],
    idToDelete: input.idToDelete || 0,
    sort: input.sort || {
      sortBy: 'id' as const,
      expiry_date: -1,
      id: 1,
      issue_date: -1,
      license_num: -1,
      license_type: -1,
      status: -1,
    },
  }),
  initial: '$_IDLE',
  on: {
    ON_GET: {
      target: '.$_GET',
      actions: 'loadingTrue',
    },
  },
  states: {
    $_IDLE: {},
    $_VIEW: {},
    $_GET: {
      invoke: {
        id: 'getData',
        src: 'getData',
        input: ({ context, event }) => ({ context, event }) as Scope,
        onDone: {
          target: '$_VIEW',
          actions: ['setData', 'loadingFalse', assign({ error: false })],
        },
        onError: {
          target: '$_VIEW',
          actions: ['sendError', 'loadingFalse', assign({ error: true })],
        },
      },
    },
  },
});
